import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { OptionMarketStatus, ParticipantMarketType, ParticipantStatus } from '@cds/betting-offer';
import { EventOption, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { ForecastComponentMode, WinGameFixture, WinGameParticipant } from '@frontend/sports/racing/feature/models';
import { cloneDeep } from 'lodash-es';

import { ParticipantPickType } from '../../../betslip-base/models/pick-models';
import { GreyhoundTrackingService } from '../../common/greyhound-tracking.service';

export enum PickType {
    StraightForecast = 'StraightForecast',
    StraightTricast = 'StraightTricast',
}

export interface Ipayload {
    map: Map<string, { [key: string]: PickType }>;
}

@Component({
    selector: 'ms-timeform-pick',
    templateUrl: './timeform-pick.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TimeFormPickComponent implements OnChanges {
    @Input() fixture: WinGameFixture;
    @Input() tab: string;
    @Input() participantOptionGroups: { [id: string]: EventOption[] } = {};
    @Input() optionGroup: EventOptionGroup;
    @Input() isracingpostPickDisabled: boolean;
    participantModel: WinGameParticipant[];
    forecastModel: WinGameParticipant[] = [];
    postPickModel: WinGameParticipant[] = [];
    isForecastAvailable: boolean;
    marketType: ParticipantMarketType;
    participantPickType: ParticipantPickType;
    isForecastSelected = false;
    addTimeFormPost: string;
    timeFormPostAdded: string;
    trackingSource: string;
    trackingOptions: { [key: string]: string };

    constructor(
        public sitecore: Sitecore,
        private greyhoundTrackingService: GreyhoundTrackingService,
    ) {}

    ngOnChanges(changes: ISimpleChanges<TimeFormPickComponent>): void {
        if (changes.fixture && changes.fixture.currentValue) {
            this.participantPickType = this.tab === ForecastComponentMode.Tricast ? ParticipantPickType.Tricast : ParticipantPickType.Forecast;
            this.marketType = this.tab === ForecastComponentMode.Forecast ? ParticipantMarketType.Forecast : ParticipantMarketType.Tricast;

            this.participantModel = this.buildParticipants(changes.fixture.currentValue);
            this.forecastModel =
                this.tab === ForecastComponentMode.Forecast
                    ? cloneDeep(this.participantModel).splice(0, 2)
                    : cloneDeep(this.participantModel).splice(0, 3);

            this.addTimeFormPost =
                this.tab === ForecastComponentMode.Forecast
                    ? this.sitecore.horseRacing.raceDetails.TimeFormForecast
                    : this.sitecore.horseRacing.raceDetails.TimeFormTricast;

            this.timeFormPostAdded =
                this.tab === ForecastComponentMode.Forecast
                    ? this.sitecore.horseRacing.raceDetails.TimeFormForecastSelected
                    : this.sitecore.horseRacing.raceDetails.TimeFormTricastSelected;

            this.trackingSource = 'horseracing_Racecard/' + (this.tab === ForecastComponentMode.Forecast ? 'forecast_timeform' : 'triast_timeform');
            this.trackingOptions = this.greyhoundTrackingService.getAdditionalTrackingOptions(this.fixture, this.trackingSource);
        }
    }

    private buildParticipants(fixture: WinGameFixture) {
        const participants = fixture.participants
            .filter((p) => !!p.timeformInfo?.analystRating && p.status === ParticipantStatus.NotDefined)
            .sort((a, b) => (a.timeformInfo?.analystRating || 0) - (b.timeformInfo?.analystRating || 0));

        return participants;
    }

    isButtonDisabled(): boolean {
        const isMarketSuspended =
            this.fixture.isOptionBet && this.optionGroup
                ? this.fixture.optionMarkets.find((o) => o.id.toString() === this.optionGroup.id)?.status === OptionMarketStatus.Suspended
                : false;

        return isMarketSuspended;
    }

    pickSelected($event: boolean) {
        this.isForecastSelected = $event;
    }
}
